import { gql } from 'graphql-request'

class PlaceMutations {
  requestClaimPlace = gql`
    mutation RequestClaimPlace($googlePlaceId: String!) {
      requestClaimPlace(googlePlaceId: $googlePlaceId) {
        id
        name
      }
    }
  `

  requestClaimPlaceByGoogleId = gql`
    mutation claimPlace($customerId: String!, $where: PlaceWhereUniqueInput!) {
      claimPlace(customerId: $customerId, where: $where) {
        id
      }
    }
  `

  unclaimPlace = gql`
    mutation unclaimPlace($where: PlaceWhereUniqueInput!) {
      unclaimPlace(where: $where) {
        id
      }
    }
  `
  updatePlace = gql`
    mutation updatePlace($where: PlaceWhereUniqueInput!, $data: PlaceUpdateInput!) {
      updatePlace(where: $where, data: $data) {
        id
        description
      }
    }
  `

  respondToPlaceClaimRequest = gql`
    mutation respondToPlaceClaimRequest($placeId: ID!, $action: PlaceClaimRequestAction!) {
      respondToPlaceClaimRequest(placeId: $placeId, action: $action) {
        id
      }
    }
  `
}

const placeMutations = new PlaceMutations()

export default placeMutations
